import { CommitmentChat } from '../../../coaching-base/general';
import { Chat, ChatMember, ChatMessage } from '../../../teams-call';

import { ChatBubble } from './model/chat-bubble.model';

export interface TeamschatDialogState {
    hasPendingData?: boolean;
    commitmentChat?: CommitmentChat;
    isMember?: boolean;
    chat?: Chat;
    chatMember?: ChatMember;
    messages: ChatMessage[];
    behaviour?: string;
    subBehaviour?: string;
    conversation: ChatBubble[];
    errorCode?: number;
}

export const defaultState = (): TeamschatDialogState => ({
    messages: [],
    conversation: [],
});
